"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prefer-promise-reject-errors */
var axios_1 = __importDefault(require("axios"));
var Cookies_1 = __importDefault(require("./Cookies"));
var utilities_1 = require("../utilities");
var constants_1 = require("../constants");
var getAssignedBucketAndSetCookie = function (response, cacheMinutes, name, experimentWithUndefinedBucket) {
    var bucketKey = response.data.content.bucketKey;
    if (!bucketKey) {
        return experimentWithUndefinedBucket;
    }
    if (cacheMinutes !== 0) {
        Cookies_1.default.set(name, bucketKey, cacheMinutes);
    }
    return {
        assignedBucket: bucketKey,
        experimentName: name
    };
};
var ExperimentBucketApi = /** @class */ (function () {
    function ExperimentBucketApi() {
    }
    ExperimentBucketApi.getBcidWithAltIdExperimentBucket = function (_a) {
        var name = _a.name, identifier = _a.identifier, _b = _a.environment, environment = _b === void 0 ? process.env.NODE_ENV : _b, _c = _a.cacheMinutes, cacheMinutes = _c === void 0 ? 15 : _c, killSwitch = _a.killSwitch;
        return __awaiter(this, void 0, void 0, function () {
            var experimentWithUndefinedBucket, kongBaseUrl;
            return __generator(this, function (_d) {
                experimentWithUndefinedBucket = {
                    assignedBucket: undefined,
                    experimentName: name
                };
                if (killSwitch === 'on') {
                    return [2 /*return*/, experimentWithUndefinedBucket];
                }
                kongBaseUrl = utilities_1.getKongBaseUrl(environment);
                return [2 /*return*/, axios_1.default({
                        method: 'post',
                        url: "https://" + kongBaseUrl + "/api/v3/buckets/alt-id",
                        data: {
                            experimentName: name,
                            identifier: identifier
                        },
                        timeout: constants_1.API_TIMEOUT
                    })
                        .then(function (res) {
                        return getAssignedBucketAndSetCookie(res, cacheMinutes, name, experimentWithUndefinedBucket);
                    })
                        .catch(function () {
                        return experimentWithUndefinedBucket;
                    })];
            });
        });
    };
    return ExperimentBucketApi;
}());
exports.default = ExperimentBucketApi;
